import ScrollInView from "./ScrollInView.js";

/**
 * @param {{
 *  loadingSections: HTMLElement[],
 *  onLoad: (HTMLElement) => void | undefined
 * }} param0
 * @returns {Component}
 */
const LoadingMovies = ({ loadingSections, onLoad }) => {
  return ScrollInView({
    componentName: "LoadingMovies",
    observables: loadingSections,
    unobserveOnEnter: true,
    onEnter: (loadedSection) => {
      loadedSection.querySelectorAll("a.movie").forEach((link) => {
        const movieSlug = link?.getAttribute("href")?.split("/movie/")[1];
        link.querySelector(".item-content").innerHTML = window.movieData?.[movieSlug]?.["item-content"] || "";
        link.querySelector(".item-subtitle").innerHTML = window.movieData?.[movieSlug]?.["item-subtitle"] || "";
      });
      loadedSection.classList.remove("loading");

      if (onLoad) {
        onLoad(loadedSection);
      }
    },
  });
};

export default LoadingMovies;
